export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.8-1718.29",
  commitId: "6fc03685578d10eb6a07feb9c7be6e0c6a4ef903",
  commitTime: "2026-10-08T17:18:29.000Z",
});
